/**
 * localStorage keys for a trainee's in-progress run state.
 *
 * These keys used to be `lesson-state-18` and `sheet-url-19` — the module id
 * and nothing else. On a shared machine (a training room, a handed-over
 * laptop) the next person to sign in was shown the previous trainee's
 * completion screen, score and spreadsheet link, because localStorage is per
 * browser profile and knows nothing about who is signed in.
 *
 * Scoping the key to the uid fixes new writes. `clearLegacyKey` deals with
 * what is already sitting in people's browsers: the unscoped key is removed
 * the first time a scoped component mounts, so the leak does not survive one
 * visit. Nothing of value is lost — Firestore holds the authoritative
 * completion, and the local copy only exists to resume an unfinished run.
 */

/** `lesson-state-<uid>-<moduleId>`, or `…-anon-…` when signed out. */
export function scopedKey(prefix, uid, moduleId) {
  return `${prefix}-${uid || 'anon'}-${moduleId}`
}

/** The pre-uid key shape, kept only so it can be deleted. */
export function legacyKey(prefix, moduleId) {
  return `${prefix}-${moduleId}`
}

/** Remove the unscoped key for this prefix/module. Safe in private mode. */
export function clearLegacyKey(prefix, moduleId) {
  try {
    localStorage.removeItem(legacyKey(prefix, moduleId))
  } catch { /* private mode, or no localStorage at all */ }
}
